"use client";

import { Fragment, useCallback, useEffect, useState } from "react";

import StepContainer from "../../../../components/new_components/StepContainer";
import StepInput from "../../../../components/new_components/StepInput";
import CardSelect from "../../../../components/new_components/CardSelcted";

import {
  bankAccountOptions,
  homologateBankNameAccount,
  typeBankAccountOptions,
} from "../../../../utils/options_selects";
import FilterableSelect from "../../../../components/new_components/FilterableSelect";
import { userBankStore } from "../../../../store/creditStore/userBankStore";
import { useCreditStore } from "../../../../store/creditStore/creditUserStore";
import { stepsCreditStore } from "../../../../store/creditStore/stepsCreditStore";
import { CreditsService } from "../../../../services/credits/credits.service";
import { WarningAlert } from "../../../../components/alerts/warningAlert";
import { ErrorAlert } from "../../../../components/alerts/errorAlert";
import { InfoAlert } from "../../../../components/alerts/infoAlert";
import { creditOfferStore } from "../../../../store/creditStore/offerCreditStore";
import { useNavigate } from "react-router-dom";
import { useMobileDetection } from "../../../../hooks/use-mobile-detection";

const UpdateDatosBancariosForm = ({
  onStepChange,
  stepTitlesGeneral,
  currentStepGeneral,
  isDesktop,
  currentStep: parentStep,
}) => {
  const navigate = useNavigate();

  const { saveUserBank, loadUserBank, clearUserBank } = userBankStore();
  const { creditUserStore, saveUser, loadUser, clearUser } = useCreditStore();
  const { stepCredit, saveSteps, loadSteps, clearSteps } = stepsCreditStore();
  const { clearOfertCredit } = creditOfferStore();
  const { screenHeight } = useMobileDetection();

  const [currentStep, setCurrentStep] = useState(1);
  const [currentText, setCurrentText] = useState("Continuar");
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  const [newBankAccount, setNewBankAccount] = useState([]);
  const [currentStepResume, setCurrentStepResume] = useState(false);

  const [formDataBank, setFormDataBank] = useState({
    accountNumber: "",
    bankAccount: "",
    typeBankAccount: "",
  });

  const [errors, setErrors] = useState({});
  const [messsageAlert, setMessageAlert] = useState("");
  const [alertSession, setAlertSession] = useState(false);
  const [isOpenWarning, setIsOpenWarning] = useState(false);
  const [isOpenError, setIsOpenError] = useState(false);
  const [isOpenInfo, setIsOpenInfo] = useState(false);

  const stepTitles = [
    isDesktop
      ? "Verifica tu banco y tu número de cuenta"
      : "Verifica tu datos bancarios.",
    isDesktop
      ? "Verifica el tipo de cuenta"
      : "Verifica tu datos bancarios.",
    isDesktop
      ? "Woohoo!!, casi listos 🚀✨"
      : "Confirma el banco para el desembolso.",
  ];

  const stepSubTitles = [
    isDesktop &&
    "Verifica que los datos sean correctos, ya que seran usados para el desembolso de tu crédito.",
    isDesktop && "Verifica que el tipo de cuenta sea correcto, ya que sera usado para el desembolso de tu crédito..",
    isDesktop &&
    "Verifica cuidadosamente la información. Si tu cuenta bancaria está mal escrita tu desembolso puede tomar más tiempo",
  ];

  const totalSteps = stepTitles.length;

  /* =========================
     HELPERS
  ========================== */

  const getFormHeight = () => {
    if (screenHeight <= 490) return "200px";
    if (screenHeight <= 550) return "260px";
    if (screenHeight <= 599) return "300px";
    if (screenHeight <= 650) return "370px";
    if (screenHeight <= 800) return "470px";
    if (screenHeight <= 1000) return "660px";
    if (screenHeight > 1001) return "830px";
    return "820px";
  };

  const resetButtonState = () => {
    setIsDisabled(false);
    setIsError(false);
  };

  const editOptions = (numberStep) => {
    setCurrentText("Volver al resumen");
    setCurrentStep(numberStep);
    setCurrentStepResume(true);
    resetButtonState(); // ✅ FIX
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // ← Sin el guard if(value.length > 0) que bloqueaba el seteo
    const newValue =
      name === "accountNumber" ? String(value).replace(/\D/g, "") : value;

    setFormDataBank((prev) => ({ ...prev, [name]: newValue }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
    resetButtonState();
  };

  const validateStep = (step) => {
    const newErrors = {};
    switch (step) {
      case 1:
        if (!formDataBank.bankAccount) {
          newErrors.bankAccount = "Campo obligatorio";
          setIsDisabled(true);
        }
        if (!formDataBank.accountNumber) {
          newErrors.accountNumber = "Campo obligatorio";
          setIsDisabled(true);
        } else {
          if (!/^\d+$/.test(formDataBank.accountNumber)) {
            newErrors.accountNumber = "Solo se permiten números";
            setIsDisabled(true);
          } else if (formDataBank.accountNumber.length < 6) {
            newErrors.accountNumber = "Mínimo 6 dígitos";
            setIsDisabled(true);
          } else if (formDataBank.accountNumber.length > 20) {
            newErrors.accountNumber = "Máximo 20 dígitos";
            setIsDisabled(true);
          }
        }
        break;
      case 2:
        if (!formDataBank.typeBankAccount) {
          newErrors.typeBankAccount = "El tipo de cuenta es obligatorio";
          setIsDisabled(true);
        }
        break;

      default:
        break;
    }

    setErrors(newErrors);
    setIsError(Object.keys(newErrors).length > 0);
    return Object.keys(newErrors).length === 0;
  };

  /* =========================
     FLOW CONTROL
  ========================== */

  const handleNext = () => {
    if (!validateStep(currentStep)) return;

    setIsDisabled(true);
    saveUserBank(formDataBank);
    saveUser(formDataBank);

    if (currentStep < totalSteps) {
      if (currentStepResume) {
        setCurrentStep(totalSteps);
        setCurrentStepResume(false);
        resetButtonState(); // ✅ FIX
        return;
      }

      setTimeout(() => {
        setCurrentStep((prev) => prev + 1);
        resetButtonState(); // ✅ FIX
      }, 80);

      saveSteps({
        stepInternal: currentStep + 1,
        stepGeneral: parentStep,
        loading: false,
      });
      return;
    }

    handleSubmit();
  };

  const handlePrevGeneral = () => {
    resetButtonState(); // ✅ FIX
    setTimeout(() => {
      onStepChange(parentStep - 1);
    }, 150);
  };

  const handlePrev = () => {
    resetButtonState(); // ✅ FIX

    if (currentStep === 1) {
      handlePrevGeneral();
      return;
    }

    setTimeout(() => {
      setCurrentStep((prev) => prev - 1);
    }, 150);
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    setIsDisabled(true);

    try {
      await handleBankUpdate();
    } catch (error) {
      resetButtonState();
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenAlert = (type, message, isOpen) => {
    if (type === "warning") {
      setMessageAlert(message);
      setAlertSession(isOpen);
      setIsOpenWarning(isOpen);

      setTimeout(() => {
        setMessageAlert("");
        setAlertSession(!isOpen);
        setIsOpenWarning(!isOpen);
      }, 6000);
    }

    if (type === "error") {
      setMessageAlert(message);
      setAlertSession(isOpen);
      setIsOpenError(isOpen);

      setTimeout(() => {
        setMessageAlert("");
        setAlertSession(!isOpen);
        setIsOpenError(!isOpen);
      }, 8000);
    }
  };

  const handleOpenAlertInfo = (type, message, isOpen) => {
    if (type === "info") {
      setMessageAlert(message);
      setAlertSession(isOpen);
      setIsOpenInfo(isOpen);
    }

    setTimeout(() => {
      setMessageAlert("");
      setAlertSession(!isOpen);
      setIsOpenInfo(!isOpen);
    }, 6000);
  };

  const cleanIndexDB = useCallback(() => {
    clearUser();
    clearUserBank();
    clearOfertCredit();
    clearSteps();
    localStorage.clear();
  }, [clearUser, clearUserBank, clearOfertCredit, clearSteps]);

  const handleBankUpdate = async () => {
    try {
      const userDoc = localStorage.getItem("doc");

      if (!userDoc) {
        handleOpenAlert(
          "error",
          "No se encontró la información del usuario. Por favor, inicia sesión nuevamente.",
          true,
        );
        return;
      }

      const { error, message } = await CreditsService.updateBankCredit(
        formDataBank,
        userDoc,
      );

      if (error) {
        handleOpenAlert(
          "error",
          "No pudimos actualizar tus datos bancarios. Intenta nuevamente.",
          true,
        );
        console.error("Error al actualizar banco:", message);
        return;
      }

      // Mensaje de éxito
      handleOpenAlertInfo(
        "info",
        "¡Datos bancarios actualizados correctamente!",
        true,
      );
      onStepChange(parentStep + 1);
    } catch (error) {
      console.error("Error inesperado al actualizar banco:", error);
      handleOpenAlert(
        "error",
        "Ocurrió un error inesperado. Por favor, intenta más tarde.",
        true,
      );
    }
  };

  const getBankPrinciapl = useCallback(async () => {
    const userDoc = localStorage.getItem("doc");

    const response = await CreditsService.getBanckPrincipal(userDoc);
    if (response.message.code === 411) {
      cleanIndexDB();
      return navigate("/");
    }
    for (let i = 0; i < response.message.info.length; i++) {
      const element = response.message.info[i];
      if (element.parent === true) {
        setFormDataBank({
          bankAccount: element.bankAccount,
          accountNumber: element.accountNumber ?? null,
          typeBankAccount: element.typeBankAccount ?? null,
        });
      }
    }
  }, [cleanIndexDB, navigate]);

  /* =========================
     EFFECTS
  ========================== */

  useEffect(() => {
    let disabled = false;

    if (isLoading || isError) disabled = true;

    if (currentStep === 1) {
      if (!formDataBank.bankAccount || !formDataBank.accountNumber) {
        disabled = true;
      }
    }

    if (currentStep === 2) {
      if (!formDataBank.typeBankAccount) {
        disabled = true;
      }
    }

    setIsDisabled(disabled);
  }, [formDataBank, currentStep, isLoading, isError]);

  useEffect(() => {
    setNewBankAccount(
      bankAccountOptions.filter((b) => b.value !== 31 && b.value !== 9),
    );

    getBankPrinciapl();
  }, [getBankPrinciapl]);


  useEffect(() => {
    if (stepCredit && stepCredit.loading) {
      setCurrentStep(stepCredit.stepInternal);
      return;
    }
  }, [stepCredit]);

  useEffect(() => {
    loadUser();
    loadUserBank();
    loadSteps();
  }, [loadUser, loadUserBank, loadSteps]);

  useEffect(() => {
    if (creditUserStore) {
      setFormDataBank({
        bankAccount: creditUserStore.bankAccount,
        accountNumber: creditUserStore.accountNumber ?? null,
        typeBankAccount: creditUserStore.typeBankAccount ?? null,
      });
      if (creditUserStore.accountNumber) {
        setIsDisabled(false);
      } else {
        setIsDisabled(true);
      }
    }
  }, [creditUserStore]);

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <div
            className="space-y-6 text-center flex flex-col px-4 sm:px-6"
            style={{
              height: isDesktop && "-webkit-fill-available",
              display: isDesktop && "flex",
              justifyContent: isDesktop && "center",
              gap: isDesktop
                ? "clamp(20px, 3vh, 40px)"
                : "clamp(16px, 2vh, 24px)",
              padding: isDesktop ? "clamp(20px, 3vh, 40px)" : "16px",
            }}
          >
            {!isDesktop && (
              <p
                className="text-muted-foreground font-bold2"
                style={{
                  fontSize: "clamp(18px, 2.2vw, 24px)",
                  textAlign: "center",
                  maxWidth: "400px",
                  margin: "0 auto",
                  lineHeight: "1.3",
                }}
              >
                ¿Cual es tu número de cuenta?
              </p>
            )}

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "clamp(16px, 2.5vh, 32px)",
                minHeight: 0,
                maxWidth: isDesktop ? "600px" : "100%",
                width: "100%",
                margin: "0 auto",
              }}
            >
              <div>
                <FilterableSelect
                  options={newBankAccount.map((banck) => ({
                    label: banck.label,
                    value: banck.value,
                    icon: banck.icon,
                  }))}
                  label={"Banco"}
                  value={formDataBank.bankAccount}
                  onChange={handleInputChange}
                  name="bankAccount"
                  placeholder="Selecciona tu banco"
                  error={errors.bankAccount}
                  required
                  isDesktop={isDesktop}
                />
              </div>

              <div
                style={{
                  marginRight: isDesktop && "clamp(50px, 4vh, 50px)",
                  marginLeft: isDesktop && "clamp(50px, 4vh, 50px)",
                }}
              >
                <StepInput
                  name="accountNumber"
                  value={formDataBank.accountNumber}
                  label={"Número de cuenta"}
                  onChange={handleInputChange}
                  error={errors.accountNumber}
                  required
                  placeholder="49000000564"
                  autoFocus={true}
                  type="number"
                  isDesktop={isDesktop}
                />
              </div>
            </div>
          </div>
        );

      case 2:
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              height:
                isDesktop &&
                typeBankAccountOptions.length === 2 &&
                "-webkit-fill-available",
            }}
          >
            {!isDesktop && (
              <div
                className="text-center"
                style={{
                  width: "260px",
                }}
              >
                <p className="text-muted-foreground font-bold2 text-2xl">
                  ¿Que tipo de cuenta tienes?
                </p>
              </div>
            )}

            <CardSelect
              data={typeBankAccountOptions}
              value={formDataBank.typeBankAccount}
              name="typeBankAccount"
              error={errors.typeBankAccount}
              onChange={handleInputChange}
              multiple={false}
              isDesktop={isDesktop}
            />
          </div>
        );

      case 3:
        return (
          <div
            className="space-y-6"
            style={{
              height: isDesktop && "-webkit-fill-available",
              display: isDesktop && "flex",
              justifyContent: isDesktop && "center",
            }}
          >
            {!isDesktop && (
              <div className="text-center flex flex-col items-center">
                <h2
                  className="font-bold2 text-foreground mb-2"
                  style={{ fontSize: "20px" }}
                >
                  Woohoo!!, casi listos 🚀✨
                </h2>
              </div>
            )}
            <div
              className="space-y-3"
              style={{
                width: "-webkit-fill-available",
                display: isDesktop && "flex",
                justifyContent: isDesktop && "center",
                alignItems: isDesktop && "center",
              }}
            >
              <div
                className="grid grid-cols-1 gap-4 text-sm "
                style={{
                  backgroundColor: isDesktop ? "#565584" : "#2C2447",
                  padding: "22px 16px",
                  marginBottom: "20px",
                  borderRadius: "8px",
                  width: isDesktop && "60%",
                }}
              >
                <div className="flex flex-row justify-between group items-center">
                  <span
                    className="font-medium text-muted-foreground text-lg"
                    style={{ color: isDesktop ? "#E1DFE5" : "#BEBCC2" }}
                  >
                    Banco
                  </span>
                  <div className="flex flex-row gap-7 items-center">
                    <p
                      className="text-foreground font-bold2"
                      style={{
                        fontSize: "14px",
                        display: "flex",
                        alignItems: "center",
                        gap: 5,
                      }}
                    >
                      {homologateBankNameAccount(
                        formDataBank.bankAccount,
                        "icon",
                      ) && (
                          <span className="flex items-center">
                            {homologateBankNameAccount(
                              formDataBank.bankAccount,
                              "icon",
                            )}
                          </span>
                        )}
                      {
                        newBankAccount.find(
                          (dept) => dept.value === formDataBank.bankAccount,
                        )?.label
                      }
                    </p>
                    <div className="text-sm">
                      <button
                        type="button"
                        aria-label="Editar"
                        style={{
                          color: "#C9B8FF",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          editOptions(1);
                        }}
                      >
                        Editar
                      </button>
                    </div>
                  </div>
                </div>
                <div className="flex flex-row justify-between group items-center">
                  <span
                    className="font-medium text-muted-foreground text-lg"
                    style={{ color: isDesktop ? "#E1DFE5" : "#BEBCC2" }}
                  >
                    Tipo de cuenta
                  </span>
                  <div className="flex flex-row gap-7 items-center">
                    <p
                      className="text-foreground font-bold2"
                      style={{ fontSize: "14px", textTransform: "capitalize" }}
                    >
                      {formDataBank.typeBankAccount}
                    </p>
                    <div className="text-sm">
                      <button
                        type="button"
                        aria-label="Editar"
                        style={{
                          color: "#C9B8FF",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          editOptions(2);
                        }}
                      >
                        Editar
                      </button>
                    </div>
                  </div>
                </div>
                <div className="flex flex-row justify-between group items-center">
                  <span
                    className="font-medium text-muted-foreground text-lg"
                    style={{ color: isDesktop ? "#E1DFE5" : "#BEBCC2" }}
                  >
                    Número
                  </span>
                  <div className="flex flex-row gap-7 items-center">
                    <p
                      className="text-foreground font-bold2"
                      style={{ fontSize: "14px" }}
                    >
                      {formDataBank.accountNumber}
                    </p>
                    <div className="text-sm">
                      <button
                        type="button"
                        aria-label="Editar"
                        style={{
                          color: "#C9B8FF",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          editOptions(1);
                        }}
                      >
                        Editar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <Fragment>
      {alertSession && (
        <>
          <WarningAlert
            isOpen={isOpenWarning}
            message={messsageAlert}
            isDesktop={isDesktop}
          ></WarningAlert>
          <ErrorAlert
            isOpen={isOpenError}
            message={messsageAlert}
            isDesktop={isDesktop}
          ></ErrorAlert>

          <InfoAlert
            isOpen={isOpenInfo}
            message={messsageAlert}
            isDesktop={isDesktop}
          ></InfoAlert>
        </>
      )}
      <div className="w-full h-full">
        <StepContainer
          onNext={handleNext}
          onPrev={handlePrev}
          canGoNext={true}
          canGoPrev={
            currentStep > 0 && currentStep !== totalSteps && !currentStepResume
          }
          currentStepResume={currentStepResume}
          isDesktop={isDesktop}
          errors={isError}
          disabled={isDisabled}
          isLastStep={currentStep === totalSteps}
          isLoading={isLoading}
          nextText={currentText}
          title={stepTitles[currentStep - 1]}
          subtitle={stepSubTitles[currentStep - 1]}
          finishText="Continuar"
        >
          <div
            className={`transition-all duration-300 ease-in-out opacity-100 transform translate-x-0`}
            style={{
              width: "-webkit-fill-available",
              overflowY: "auto",
              height: isDesktop ? "-webkit-fill-available" : getFormHeight(),
            }}
          >
            {!isDesktop && (
              <div className="mb-3 text-center flex flex-col items-center">
                <div className="text-sm mb-1.5" style={{ color: "#c8cbda" }}>
                  Paso {currentStepGeneral} de {stepTitlesGeneral.length}
                </div>
                <div
                  className="text-lg font-medium text-gray-800 mt-1"
                  style={{
                    fontSize: 16,
                    fontWeight: 400,
                    width: "190px",
                    lineHeight: "1",
                  }}
                >
                  {currentStep && stepTitles[currentStep - 1]}
                </div>
              </div>
            )}
            {renderStep()}
          </div>
          {currentStep === 2 && !isDesktop && (
            <div
              style={{
                padding: "10px",
                backgroundColor: "#565584",
                color: "#E1DFE5",
                fontSize: "16px",
                borderRadius: "8px",
                marginBottom: "10px",
                marginTop: "10px",
              }}
            >
              Recuerda que la cuenta bancaria debe estar a tu nombre. Si
              proporcionas una de otra persona, tu solicitud podría anularse.
            </div>
          )}
        </StepContainer>
      </div>
    </Fragment>
  );
};

export default UpdateDatosBancariosForm;
